var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableWrapper"},[_c('FusionTable',{attrs:{"config":_vm.tableData},on:{"scrollDown":_vm.tableScroll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }